import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-details-empty',
  templateUrl: './details-empty.component.html',
  styleUrls: ['./details-empty.component.scss']
})
export class DetailsEmptyComponent {
   @Input() public primaryText!: string;
   @Input() public secondaryText!: string;
}
